const defaults = {};

const getEnv = () => {
  const env = {
    baseUrl: process.env.API_HOST,
    cognitoDomain: process.env.COGNITO_DOMAIN,
    cognitoClientId: process.env.COGNITO_CLIENT_ID,
  };
  // The member-facing account site (password reset) lives on the API host.
  env.accountHost = (env.baseUrl || '').replace(/^(https?:\/\/[^/]+).*$/, '$1');

  return Object.assign(defaults, env);
};

export default getEnv();



// WEBPACK FOOTER //
// ./src/lib/config.js